/**
 * Created by idavis on 11/10/15.
 */
angular.module('relivConference').config(['$routeProvider',
    function ($routeProvider) {
        $routeProvider
            .when('/conference/ticket', {
                templateUrl: '/app_components/conference-ui/src/ticket-list/reliv-conference-tickets-list.html',
                reloadOnSearch: false,
            })
            .when('/conference/ticket/:id', {
                templateUrl: '/app_components/conference-ui/src/ticket-details/reliv-conference-ticket-details.html',
            })
            .when('/conference/custom-badge-print', {
                templateUrl: '/app_components/conference-ui/src/badge-print/custom-badge-print.html',
            });
    },
]);
